import InlineForm from 'components/admin/Helper/InlineForm'
import { FormInput } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, initialize, reduxForm } from 'redux-form'
import { confirmationModal } from 'redux/navigation'
import { deleteValue, saveProperty, saveValue } from 'redux/properties'
import { Button, Form, Grid } from 'semantic-ui-react'
import { FormTextArea } from '../../shared/Forms/ReduxForm'
import PropertyValuesList from './PropertyValuesList'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveValue,
      deleteValue,
      saveProperty,
      confirmationModal,
      initializeRF: initialize,
    },
    dispatch
  )

class PropertiesValues extends React.Component {
  savePropertyValue({
    editingValueId: id,
    valueDe: value_de,
    valueFr: value_fr,
  }) {
    const {
      saveValue,
      selectedProperty: { id: property_id },
    } = this.props
    saveValue({ id, property_id, value_de, value_fr })
    this.stopEditing()
  }

  stopEditing() {
    const { change } = this.props
    change('editingValueId', -1)
    change('valueDe', '')
    change('valueFr', '')
  }

  deleteValue(id) {
    const { confirmationModal, deleteValue } = this.props
    confirmationModal({
      icon: config.icons.modalDelete,
      title: I18n.t('admin.property_editor.properties.delete_title'),
      button: I18n.t('admin.property_editor.properties.confirm_delete'),
      confirm: () => deleteValue(id),
    })
  }

  render() {
    const dark = config.theme.dark
    const { selectedProperty } = this.props
    const {
      selectedProperty: { property_values: propertyValues = [] },
    } = this.props
    const { change, handleSubmit, initializeRF } = this.props
    const cssClasses = classNames([
      'PropertiesValues',
      'active-window',
      'scroll',
      dark && 'inverted',
    ])
    return (
      <div className={cssClasses}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={11}>
              <Field
                component={FormInput}
                fluid
                icon="search"
                name="filterText"
                placeholder={I18n.t('global.filter')}
              />
            </Grid.Column>
            <Grid.Column width={1}>
              <Button
                primary
                fluid
                icon="plus"
                onClick={(event) => {
                  event.preventDefault()
                  initializeRF('create_property_value', {
                    valueDe: '',
                    valueFr: '',
                  })
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <InlineForm
          form="create_property_value"
          onSubmit={(formValues) => this.savePropertyValue(formValues)}
          getTitle={() =>
            I18n.t('admin.property_editor.property_values.new_property_value')
          }>
          <Form.Group widths="equal">
            <Field
              name="valueDe"
              component={FormTextArea}
              placeholder={I18n.t('navigation.languages.de')}
              icon="flag"
            />
            <Field
              name="valueFr"
              component={FormTextArea}
              placeholder={I18n.t('navigation.languages.fr')}
              icon="flag outline"
            />
          </Form.Group>
        </InlineForm>
        <PropertyValuesList
          selectedProperty={selectedProperty}
          handleSubmit={handleSubmit((data) => this.savePropertyValue(data))}
          handleCancel={() => this.stopEditing()}
          handleDelete={(id) => this.deleteValue(id)}
          setEditingValueId={(id) => {
            const editingValue = propertyValues.find(
              (propertyValue) => propertyValue.id === id
            )
            change('editingValueId', editingValue.id)
            change('valueDe', editingValue.value_de)
            change('valueFr', editingValue.value_fr)
          }}
        />
      </div>
    )
  }
}

PropertiesValues = connect(mapStateToProps, mapDispatchToProps)(
  PropertiesValues
)
PropertiesValues = reduxForm({ form: 'property_value' })(PropertiesValues)
export default PropertiesValues



// WEBPACK FOOTER //
// ./src/components/admin/Properties/PropertiesValues.jsx